<section data-testid="c360-commercial" class="c360-section">
  <header class="c360-section__head">
    <h2 class="c360-section__title">Commercial</h2>
    <p class="c360-section__subtitle">What the company pays for, and when it renews.</p>
  </header>
  <div class="c360-grid">
    <ng-container *ngIf="licencesGranted && commercial as c">
      <article data-testid="c360-licences-card" class="c360-card" [ngClass]="c.NotApplicable && !hasContractFacts ? 'c360-span-12' : 'c360-span-6'">
        <div class="c360-card__head">
          <div>
            <h3 class="c360-card__title">Licences</h3>
            <p *ngIf="!c.NotApplicable && hasContractFacts" data-testid="c360-licences-summary" class="c360-card__description">{{ licencesSummary }}</p>
            <p *ngIf="!c.NotApplicable && !hasContractFacts" class="c360-card__description">{{ c.Licences.length | adbCount:'licence' }} in Client Manager, latest billing end first.</p>
          </div>
        </div>
        <div class="c360-card__body">
          <div *ngIf="c.NotApplicable" class="c360-na" data-testid="c360-licences-na"><i class="fa-regular fa-address-card"></i> No Client Manager record</div>
          <app-admin-dashboard-empty *ngIf="!c.NotApplicable && !c.Licences.length" data-testid="c360-licences-empty" [compact]="true"
                                     icon="fa-regular fa-file-contract" [title]="'No licences'"></app-admin-dashboard-empty>
          <table *ngIf="!c.NotApplicable && c.Licences.length && hasContractFacts" data-testid="c360-package-table" class="c360-table">
            <thead>
              <tr>
                <th scope="col">Package</th>
                <th scope="col" class="c360-num">Price</th>
                <th scope="col" class="c360-num">From</th>
                <th scope="col" class="c360-num">Ends</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let licence of c.Licences" data-testid="c360-licence-row">
                <td data-testid="c360-licence-package">{{ packageOf(licence) }}</td>
                <td class="c360-num">{{ usd(licence.totalLicensePrice) }}</td>
                <td class="c360-num">{{ hasDate(licence.billingStartDate) ? (licence.billingStartDate | date:'d MMM y':'UTC') : '—' }}</td>
                <td class="c360-num">{{ hasDate(licence.billingEndDate) ? (licence.billingEndDate | date:'d MMM y':'UTC') : '—' }}</td>
                <td>
                  <span class="c360-pill status-chip" [attr.data-tone]="statusTone(licence.status)"
                        [ngClass]="'status-' + licence.status">{{ licence.status }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table *ngIf="!c.NotApplicable && c.Licences.length && !hasContractFacts" class="c360-table">
            <thead>
              <tr>
                <th scope="col">Status</th>
                <th scope="col">Contract end</th>
                <th scope="col">Billing end</th>
                <th scope="col">Owner</th>
                <th scope="col" class="c360-num">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let licence of c.Licences" data-testid="c360-licence-row">
                <td>
                  <span class="c360-pill status-chip" [attr.data-tone]="statusTone(licence.status)"
                        [ngClass]="'status-' + licence.status">{{ licence.status }}</span>
                </td>
                <td class="c360-nowrap">{{ hasDate(licence.contractEndDate) ? (licence.contractEndDate | date:'d MMM y':'UTC') : '—' }}</td>
                <td class="c360-nowrap">{{ hasDate(licence.billingEndDate) ? (licence.billingEndDate | date:'d MMM y':'UTC') : '—' }}</td>
                <td>{{ licence.ownerName }}</td>
                <td class="c360-num">{{ licence.totalLicensePrice | currency:'USD':'symbol':'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
      <article *ngIf="!c.NotApplicable || hasContractFacts" data-testid="c360-contract-card" class="c360-card c360-span-6">
        <div class="c360-card__head">
          <div>
            <h3 class="c360-card__title">Contract and billing</h3>
            <p *ngIf="!c.NotApplicable" class="c360-card__description">From the Client Manager record.</p>
          </div>
        </div>
        <dl *ngIf="hasContractFacts" data-testid="c360-contract-facts" class="c360-dl">
          <dt>Contract</dt>
          <dd data-testid="c360-contract">{{ contractText }}</dd>
          <dt>Next renewal</dt>
          <dd data-testid="c360-next-renewal">{{ nextRenewalText }}</dd>
          <dt>Account owner</dt>
          <dd data-testid="c360-owner">{{ ownerText }}</dd>
          <dt>Client Manager record</dt>
          <dd data-testid="c360-cm-record">
            <ng-container *ngIf="c.HasClientManagerRecord; else cmMissing">Yes</ng-container>
            <ng-template #cmMissing><span data-testid="c360-cm-missing" class="c360-warn">Missing</span></ng-template>
          </dd>
          <ng-container *ngIf="!c.NotApplicable">
            <dt>ARR</dt>
            <dd data-testid="c360-arr">{{ c.Arr | currency:'USD':'symbol':'1.0-0' }}</dd>
            <dt>Licensed users</dt>
            <dd>{{ c.LicensedUsers | number }}</dd>
            <dt>Licensed entities</dt>
            <dd>{{ c.LicensedEntities | number }}</dd>
          </ng-container>
        </dl>
        <dl *ngIf="!hasContractFacts" class="c360-dl">
          <dt>Client Manager name</dt>
          <dd>{{ c.ClientName }}</dd>
          <dt>ARR</dt>
          <dd data-testid="c360-arr">{{ c.Arr | currency:'USD':'symbol':'1.0-0' }}</dd>
          <dt>Licensed users</dt>
          <dd>{{ c.LicensedUsers | number }}</dd>
          <dt>Licensed entities</dt>
          <dd>{{ c.LicensedEntities | number }}</dd>
        </dl>
      </article>
    </ng-container>
    <article *ngIf="billingGranted && transactions as t" data-testid="c360-transactions-card" class="c360-card"
             [ngClass]="showRenewals ? 'c360-span-6' : 'c360-span-12'">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">Transactions, last 12 months</h3>
          <p data-testid="c360-transactions-summary" class="c360-card__description">{{ t.Transactions.length | adbCount:'transaction' }} · {{ t.Total12m | currency:'USD':'symbol':'1.0-0' }} in total.</p>
        </div>
      </div>
      <div class="c360-card__body">
        <app-admin-dashboard-empty *ngIf="!t.Transactions.length" data-testid="c360-transactions-empty" [compact]="true"
                                   icon="fa-regular fa-receipt" [title]="'No billing in the last 12 months'"></app-admin-dashboard-empty>
        <div *ngIf="t.Transactions.length" data-testid="c360-transactions-scroll" class="c360-scroll">
          <table class="c360-table">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Description</th>
                <th scope="col" class="c360-num">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of t.Transactions" data-testid="c360-transaction-row">
                <td class="c360-nowrap">{{ transaction.date | date:'d MMM y':'UTC' }}</td>
                <td>{{ transaction.description }}</td>
                <td class="c360-num">{{ transaction.amount | currency:'USD':'symbol':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
    <app-admin-dashboard-c360-renewal-history *ngIf="showRenewals" data-testid="c360-renewal-history" class="c360-span-6"
                                              [history]="commercial.RenewalHistory"
                                              [hasRecord]="commercial.HasClientManagerRecord !== false"></app-admin-dashboard-c360-renewal-history>
  </div>
</section>
